import { AutogenModelCustomFilename, AutogenRowCustomFilename } from "./autogen/AutogenModelCustomFilename";

export class ModelCustomFilename extends AutogenModelCustomFilename<RowCustomFilename> {
	constructor() {
		super(RowCustomFilename);
	}
}

export class RowCustomFilename extends AutogenRowCustomFilename {
}